<template>
  <div id="app">
    <navigation>
      <router-view></router-view>
    </navigation>
  </div>
</template>

<script>
  export default {
    name: 'App',
    methods: {

    },
    data() {
      return {
      }
    },
  }

</script>

<style>
  /* @import "style/my.css"; */
  @import "../static/iconfont/iconfont.css";
  @import "style/font.css";
*{
   font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
 }
 .van-toast{
   top: 42% !important;
 }
 body,html{
   max-width: 750px;
   margin: 0 auto;
   font-size: 16px;
   -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
 }
 p{
   padding: 0;
   margin: 0;
 }
 ul ::marker,ol ::marker {
   font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif!important;
}
.fx{
   display: flex;
   align-items: center;
   justify-content: space-between;
 }
 /* 通用遮罩层 */
 .share_bj{
   width: 100%;
   height: 100vh;
   background: rgba(0, 0, 0, 0.3);
   position: absolute;
   left: 0;
   top: 0;
 }
 .share_bj img{
   width: 4rem;
   position: absolute;
   left: 36%;
   top: -2%;
 }
 img{
  pointer-events: none;
  -webkit-user-select:none;
  -moz-user-select:none;
  user-select:none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue